import React from "react"; 
const FieldValidationErrorMsg = ({ field,errors}) => {
    return (  
        <span className="text-danger">{errors[field]?.message}</span>
    );
}
export default FieldValidationErrorMsg;
